export default __webpack_public_path__ + "static/img/hot-water.376979a.png";